import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '../src/styles/globals.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);